"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeNestedModelArrayObject = exports.makeNestedModelObject = exports.makeNestedModelArray = exports.toInt = void 0;
const convert_1 = require("./convert");
const toInt = ({ value }) => {
    return Number.parseInt(value, 10);
};
exports.toInt = toInt;
const makeNestedModelArray = (modelCtor) => {
    return ({ value: item }) => {
        if (!(item instanceof Array)) {
            return typeof item === "undefined" ? undefined : null;
        }
        return item.map((value) => (0, convert_1.makeModel)(modelCtor, value));
    };
};
exports.makeNestedModelArray = makeNestedModelArray;
const makeNestedModelObject = (modelCtor) => {
    return ({ value }) => {
        if (typeof value !== "object" || value.constructor.name !== "Object") {
            return typeof value === "undefined" ? undefined : null;
        }
        const modelValue = {};
        Object.keys(value).forEach((key) => {
            const propValue = value[key];
            modelValue[key] = (0, convert_1.makeModel)(modelCtor, propValue);
        });
        return modelValue;
    };
};
exports.makeNestedModelObject = makeNestedModelObject;
const makeNestedModelArrayObject = (modelCtor) => {
    return ({ value }) => {
        if (typeof value !== "object" || value.constructor.name !== "Object") {
            return typeof value === "undefined" ? undefined : null;
        }
        const modelValue = {};
        Object.keys(value).forEach((key) => {
            const values = value[key];
            modelValue[key] =
                values instanceof Array ? values.map((v) => (0, convert_1.makeModel)(modelCtor, v)) : null;
        });
        return modelValue;
    };
};
exports.makeNestedModelArrayObject = makeNestedModelArrayObject;
//# sourceMappingURL=transform.js.map